"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ViewHideIcon = function ViewHideIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.846 7.87c-.558.69-3.523 4.13-7.287 4.13a6.871 6.871 0 0 1-2.166-.37l.809-.809A5.594 5.594 0 0 0 8.559 11c2.973 0 5.511-2.61 6.29-3.5a13.195 13.195 0 0 0-2.276-2.05l.721-.721a13.92 13.92 0 0 1 2.55 2.4l.002.002a.58.58 0 0 1 0 .738zM5.535 10.176l-.742.742-.003-.002-2.27 2.27-.707-.707 2.107-2.107a14.436 14.436 0 0 1-2.756-2.495.581.581 0 0 1 .001-.758C1.738 6.434 4.793 3 8.56 3a6.83 6.83 0 0 1 2.308.426L13.48.813l.707.707-2.328 2.328.003.002-.753.753-.003-.002-1.14 1.14.002.003-3.224 3.224-.002-.003-1.21 1.21zm-.89-.528l1.622-1.623a2.28 2.28 0 0 1 2.76-2.76l1.046-1.046A5.587 5.587 0 0 0 8.559 4C5.58 4 2.969 6.605 2.16 7.5a13.663 13.663 0 0 0 2.483 2.149zM10.8 7.5a2.29 2.29 0 0 0-.06-.503L7.998 9.741A2.286 2.286 0 0 0 10.8 7.5z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.5 14.8a3.29 3.29 0 0 1-.598-.06l3.838-3.838A3.272 3.272 0 0 1 12.5 14.8zm6.63-7.29l-.72.722a19.815 19.815 0 0 1 3.45 3.268c-.977 1.19-4.833 5.5-9.361 5.5a8 8 0 0 1-2.455-.404l-.782.783A9.238 9.238 0 0 0 12.5 18c5.708 0 10.212-5.948 10.4-6.201l.224-.299-.224-.299a20.063 20.063 0 0 0-3.77-3.69zM5.5 19.208l-.707-.707 2.231-2.231A19.774 19.774 0 0 1 2.1 11.8l-.224-.299.224-.299C2.288 10.948 6.792 5 12.5 5a9.944 9.944 0 0 1 4.573 1.22L19.5 3.793l.707.707zm2.253-3.667l2.095-2.095A3.27 3.27 0 0 1 9.2 11.5a3.304 3.304 0 0 1 3.3-3.3 3.27 3.27 0 0 1 1.945.648l1.883-1.883A8.759 8.759 0 0 0 12.5 6c-4.528 0-8.384 4.31-9.361 5.5a18.915 18.915 0 0 0 4.614 4.04z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.5 20a4.44 4.44 0 0 1-1.18-.177l5.503-5.503A4.44 4.44 0 0 1 21 15.5a4.505 4.505 0 0 1-4.5 4.5zm7.985-9.342l-.723.722a25.428 25.428 0 0 1 4.908 4.12C27.062 17.239 22.149 22 16.5 22a11.158 11.158 0 0 1-2.942-.415l-.8.8A12.385 12.385 0 0 0 16.5 23c7.456 0 13.5-7.5 13.5-7.5a26.034 26.034 0 0 0-5.515-4.842zM8.354 24.354l-.707-.707 2.397-2.398A25.335 25.335 0 0 1 3 15.5S9.044 8 16.5 8a13.313 13.313 0 0 1 5.502 1.29l2.644-2.644.707.707zm2.436-3.85L13 18.292a4.455 4.455 0 0 1-1-2.793 4.505 4.505 0 0 1 4.5-4.5 4.455 4.455 0 0 1 2.793 1l1.952-1.952A12.113 12.113 0 0 0 16.5 9c-5.65 0-10.562 4.76-12.169 6.501a24.143 24.143 0 0 0 6.459 5.002z"
  }));
};

var _default = ViewHideIcon;
exports["default"] = _default;